import React, { useEffect, useState } from 'react';
import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';

import AccountManager from '../account/AccountManager';
import agent from '../../lib/agent';
import useStores from '../../stores/useStores';

const ProfilePicker = () => {
  const history = useHistory();
  const { modalStore, userStore, projectStore } = useStores();
  const [userGroups, setUserGroups] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await agent.User.getGroups();
      setUserGroups(response.data.data);
    })();
  }, []);
  const handleClose = () => {
    modalStore.setModal(null);
  };

  const handleGroupClick = async group => {
    await userStore.switchGroup(group.id);
    history.push(`/`);
    projectStore.fetchAll();

    handleClose();
  };
  if (!userGroups.length) return null;
  return (
    <Dialog onClose={handleClose} open>
      <AccountManager
        onSelectAccount={handleGroupClick}
        accounts={userGroups}
      />
    </Dialog>
  );
};

export default observer(ProfilePicker);
